const RestrictionTypes = {
  stateLicenseRequired: 'state_license_required',
} as const

export default RestrictionTypes
